/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Get_CaptionInputs */

const en_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Named, typed fields in the same shape whichever source answers.`)
};

const zh_hans1_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字段有名称、有类型，无论哪个数据源响应，结构都一样。`)
};

const pt_br2_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campos nomeados e tipados, no mesmo formato, seja qual for a fonte que responder.`)
};

const es_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campos con nombre y tipo, con el mismo formato sin importar qué fuente responda.`)
};

const fr_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des champs nommés et typés, dans la même forme quelle que soit la source qui répond.`)
};

const de_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benannte, typisierte Felder in derselben Struktur, egal welche Quelle antwortet.`)
};

const ru_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Именованные типизированные поля в одном формате, какой бы источник ни ответил.`)
};

const it_endpoint_reference_get_caption = /** @type {(inputs: Endpoint_Reference_Get_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campi con nome e tipo nella stessa struttura, qualunque fonte risponda.`)
};

/**
* | output |
* | --- |
* | "Named, typed fields in the same shape whichever source answers." |
*
* @param {Endpoint_Reference_Get_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_get_caption = /** @type {((inputs?: Endpoint_Reference_Get_CaptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Get_CaptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_get_caption(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_get_caption(inputs)
	if (locale === "es") return es_endpoint_reference_get_caption(inputs)
	if (locale === "fr") return fr_endpoint_reference_get_caption(inputs)
	if (locale === "de") return de_endpoint_reference_get_caption(inputs)
	if (locale === "ru") return ru_endpoint_reference_get_caption(inputs)
	if (locale === "it") return it_endpoint_reference_get_caption(inputs)
	return en_endpoint_reference_get_caption(inputs)
});